import { render, staticRenderFns } from "./ManageGoods.vue?vue&type=template&id=b8580c24&scoped=true"
import script from "./ManageGoods.vue?vue&type=script&lang=js"
export * from "./ManageGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8580c24",
  null
  
)

export default component.exports